import styled from 'styled-components';

export const StyledHugeTooltip = styled.div`
    width: 90%;
    display: ${(props: any) => props.display};
    flex-direction: column;
    position: ${(props: any) => props.positionValue};
    left: 0;
    bottom: ${(props: any) => props.bottomPosition};
    transform: ${(props: any) => props.transformValue};
    padding: 12px 6px;
    background-color: white;
    border: 1px solid #909090;
    border-radius: 8px;
    z-index: 5;
    white-space: break-spaces;

    h3,
    h4 {
        margin: 0;
        font-weight: 400;
    }

    h3 {
        font-size: 16px;
    }

    h4 {
        font-size: 14px;
        margin-bottom: 8px;

        img {
            display: inline;
            position: unset;
        }
    }

    p {
        margin: 0;
        color: gray;
        font-size: 14px;
    }
` as any;
